/// <reference path="https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js" />

(function (global, document, $) {
    'use strict';

    // Accordion
    $.fn.accordion = function () {
        $('.accordion').children('').on('click', function () {
            $(this).parent('.accordion').toggleClass('accordion-show');
            $(this).parent('.accordion').toggleClass('accordion-hidden');
        });


    };

    $('.accordion').accordion();

    // CODE FOR UI WIDGETS AND STYLE ADJUSTMENTS FOR MEDIUM AND SMALL DISPLAY SIZES 
    function initializeMobileNavigation() {
        // func of plus btns class .submenu-btn
        $('.main-header-mobile .submenu-btn').click(function () {
            $(this).toggleClass('collapsed');
            $(this).first().parent().children('.collapse').collapse('toggle');
        });

        // close main nav menu when clicked outsite
        $(document).click(function (e) {
            // second check if clicked outsite of menu
            if (!$(e.target).hasClass('#navigation') && $(e.target).parents('.collapse').length === 0) {
                $('#navigation').collapse('hide');
                $('.main-mobile-btn').addClass('collapsed');
                // and all others
                $('.main-header-mobile .sub-menu').collapse('hide');
                $('.main-header-mobile .submenu-btn').addClass('collapsed');
            }
        });

        $('#HeaderMoreMenu').click(function () {
            $(this).toggleClass('open');
            $('#HeaderNavMenu').toggleClass('open');
        })

        $('#NavigationMoreMenu').click(function () {
            $(this).toggleClass('open');
            $('#header-menu').toggleClass('open');
        })
    }

    $(function () {
        initializeMobileNavigation();
    });

    // Selector
    $.fn.bizSelector = function (dropdownSelector) {

        var instance = this;
        var $dropdown = $(dropdownSelector);
        var $states = instance.find('div');
        var dataForDropdown = $.map($states, function (el) { return $(el).data().title; });

        function hideAllStates() {
            $states.each(function (index, value) { $(value).hide(); });
        }

        function showSelectedState() {
            var selectedState = $dropdown.val();
            var targetState = $states.filter(function (i, el) {
                return $(el).data().title === selectedState;
            });
            hideAllStates($states);
            targetState.show();
        }

        function populateDropdown() {
            $(dataForDropdown).each(function (index, value) {
                $dropdown.append($('<option></option>').val(value).html(value));
            });
        }

        function initialize() {
            hideAllStates();
            $states.first().show();
            populateDropdown();

            $dropdown.change(function () {
                showSelectedState.call(instance);
            });
        }

        initialize();

        return instance;
    };

    // Shared
    function initPartnersSlider($sliderContainer) {
        var $slideCollection = $sliderContainer.find('.partners-slide');
        var $nextSlideBtn = $('#partners-slide-next');
        var $prevSlideBtn = $('#partners-slide-prev');

        $nextSlideBtn.on('click', function (ev) {
            var $current = $sliderContainer.find('.slide-visible');
            var $next = $current.next();

            $current.removeClass('slide-visible');

            if ($next.length) {
                $next.addClass('slide-visible');
            } else {
                $slideCollection.first().addClass('slide-visible');
            }
        });

        $prevSlideBtn.on('click', function (ev) {
            var $current = $sliderContainer.find('.slide-visible');
            var $prev = $current.prev();

            $current.removeClass('slide-visible');

            if ($prev.length) {
                $prev.addClass('slide-visible');
            } else {
                $slideCollection.last().addClass('slide-visible');
            }
        });
    }

    function initManagingYourBusinessDrawer(selector) {
        var tabActiveClassName = 'drawer-tab-expanded';
        var $drawerContainer = $(selector);
        var $drawerContent = $drawerContainer.find('#drawer-content');
        var $drawerTabs = $drawerContainer.find('.drawer-tab');

        $drawerTabs.on('click', function (ev) {
            var tabId = ev.currentTarget.id;
            var contentId = '#' + tabId + '-content';
            var $currentTab = $(this);

            $currentTab.toggleClass(tabActiveClassName)
                .siblings()
                .removeClass(tabActiveClassName);

            $drawerContent.find('.drawer-tab-content')
                .not(contentId)
                .hide();

            $drawerContent.find(contentId).slideToggle();
        });

        $drawerContent.find('.btn-close-mini').on('click', function (ev) {
            var $closeBtn = $(ev.currentTarget);
            $closeBtn.closest('.drawer-tab-content').slideUp();
            $drawerTabs.removeClass(tabActiveClassName);
        });
    }

    function loadBLPage() {
        window.location.href = $('#BLWizardURL').val();
    }

    $(function () {
        //$('#header-menu, #incorporate-now-menu').kendoMenu();

        /* Featherlight jQuery plugin for image and video popups
           docs: https://github.com/noelboss/featherlight/#installation */
        $('a[data-video-url]').each(function (index, val) {
            $(val).attr('data-featherlight',
                '<div><video class="" src="'
                + $(val).data().videoUrl
                + '" autoplay controls></video></div>');
        });

        /* State Guides Select Whitebox */
        $('#state-guides-whitebox #view-state-guide').on('click', function (ev) {
            var state = $('#state-guide').val();
            var topic = $('#state-guide-topic').val();

            if (!(state && topic)) {
                $('#view-state-guide-error-msg').show();
            } else {
                global.location.href = '/learn/state-guides/' + state + '/' + topic;
            }
        });

        /* Partners Whitebox With Slider */
        var $partnersSliderContainer = $('#partners-slides');

        if ($partnersSliderContainer && $partnersSliderContainer.length) {
            initPartnersSlider($partnersSliderContainer);
        }

        //TODO: Move to a separate file
        initManagingYourBusinessDrawer('#managing-your-business-banner-container');

        /* Prevent initial page rendering glitch when js/css files are before closing body tag */
        $('#PublicWrapper').css('visibility', 'inherit');

        /* prevent default closing settings on the help dropdown in header */
        $(document).on('click', '.main-header #sec-nav-help.open .dropdown-menu', function (e) {
            e.stopPropagation();
        });

        $('.main-header #sec-nav-help .close-help-btn').on('click', function () {
            $('.main-header #header-help-menu').dropdown('toggle');
        });

        $('.podcast-list a.new_window').click(function () {
            window.open($(this).attr('href'), 'podcast_player', 'width=570, height=410');
            return false;
        });

        $('#btn-blwizard').click(function (e) {
            loadBLPage();
        });

        $('#footerWizard').click(function (e) {
            e.preventDefault();
            loadBLPage();
        });

        $('#btnCheckNow_Home').click(function (e) {
            e.preventDefault();
            loadBLPage();
        });

        $('#btnPreviewNow_StartingBusiness').click(function (e) {
            e.preventDefault();
            loadBLPage();
        });
    });

    $(document).ready(function () {
        $('#copyright-year').text(function () {
            return new Date().getFullYear();
        });
    });

    // Slider
    $.fn.bizSlider = function (controlsId, autoSlideTimeout) {

        var context = this;

        function syncVisibleSlide() {
            context.children().hide();
            context.sliderController.find('li').each(function (index, sliderBullet) {
                var $sliderBullet = $(sliderBullet);

                if (context.currentSlideIndex === index) {
                    $sliderBullet.addClass('active-bullet');
                }
                else {
                    $sliderBullet.removeClass('active-bullet');
                }
            });
            context.children().eq(context.currentSlideIndex).show();
        }

        function setVisibleSlide(slideIndex) {
            context.currentSlideIndex = slideIndex;
            syncVisibleSlide.call(context);
        }

        function initializeControls() {
            context.sliderController = $(controlsId);
            var controllerList = $('<ul></ul>');

            for (var i = 0; i < context.slidesCount; i++) {
                controllerList.append('<li></li>');
            }

            context.sliderController.append(controllerList);

            context.sliderController.find('li').click(function (event) {
                var clickedIndex = $(event.currentTarget).index();
                setVisibleSlide.call(context, clickedIndex);
            });
        }

        function intervalCallback() {
            context.slideNext();
        }

        context.slideNext = function () {
            this.currentSlideIndex = ++this.currentSlideIndex % this.slidesCount;
            syncVisibleSlide.call(this);
        };

        context.slidePrevious = function () {
            this.currentSlideIndex = (--this.currentSlideIndex + this.slidesCount) % this.slidesCount;
            syncVisibleSlide.call(this);
        };

        context.startSlider = function () {
            context.callbackHandle = setInterval(intervalCallback, autoSlideTimeout);
        };

        context.stopSlider = function () {
            clearInterval(context.callbackHandle);
        };

        context.currentSlideIndex = 0;
        context.slidesCount = this.children().length;

        initializeControls();
        syncVisibleSlide();

        if (autoSlideTimeout > 0) {
            context.startSlider();
        }

        return this;
    };

}(window, document, jQuery));